import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async getResourceGroupList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getResourceGroupList`, data)
                    
                    if (!result.data.errorCode || result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async getResourceGroupDetail(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getResourceGroupDetail`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async createResourceGroup(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/createResourceGroup`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async updateResourceGroup(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/updateResourceGroup`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async deleteResourceGroup(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/deleteResourceGroup`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;